export default class ApplicationStatusDomainService {
    static get CompletedId() {
        return "5be91b8d-cede-4274-98f6-8e956c95e632";
    }
    static get InProgressId() {
        return "f92d6381-1eec-42fd-87b9-0550bfabf73f";
    }
    static get NoneId() {
        return "955ae0d4-cb8b-42b1-8dd3-c1ee0ef2b2d4";
    }
    static get NewId() {
        return "e5e45f25-1d0b-47c5-a08d-910459fc0c82";
    }
    static get CancelledId() {
        return "9610ce7c-ef38-444a-8468-d549be3e3f1d";
    }
    static get IncompleteId() {
        return "18d45c03-4254-48af-8a78-89a121595e80";
    }
}
